import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import BoxTypeDetailsForm from "../../../components/forms/setup/boxTypes/BoxTypeDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function BoxTypesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [boxTypes, setBoxTypes] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getBoxTypes = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `boxTypes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setBoxTypes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createBoxType = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("boxTypes/create", payload);

    if (callResult.success) {
      showSuccess("BoxType added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getBoxTypes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateBoxType = async function (values, index) {
    let callResult = await makePutApiCall(`boxTypes/${values.id}`, values);

    if (callResult.success) {
      showSuccess("BoxType updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...boxTypes.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setBoxTypes({ ...boxTypes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddBoxTypeSlideOver = (isEdit, boxType, index) => {
    setSlideOver({
      childComponent: (
        <BoxTypeDetailsForm
          boxType={boxType}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateBoxType(payload, index) : createBoxType(payload)
          }
          title={isEdit ? `Update ${boxType.name}` : "Add new boxType"}
        />
      ),
      open: true,
    });
  };

  const deleteBoxType = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteBoxType/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = boxTypes.data.filter((item) => item.id !== id);
      setBoxTypes({ ...boxTypes, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteBoxType = function (boxType, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteBoxType(boxType.id, index)}
          message={`Are you sure you want to delete  ${boxType.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddBoxTypeSlideOver,
    getBoxTypes,
    loading,
    boxTypes,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteBoxType,
  };
}
